import React, { useEffect, useState } from "react";
import "./styles/index.scss";
import Switcher from "../../../common/forms/switcher";
import * as api from "../../../../api/generated-api";
import { states } from "../../../common/widgets/formVariablesWidget";
import DKFormTextInput from "../../../common/widgets/formVariablesWidget/DKFormTextInput";
import DKFormMoneyInput from "../../../common/widgets/formVariablesWidget/DKFormMoneyInput";

type InvestorCreateBaseFormProps = {
  investor: api.DealInvestorCreate | api.DealInvestor;
  onChange: (investor: api.DealInvestorCreate | api.DealInvestor) => void;
};

const InvestorCreateBaseForm = (props: InvestorCreateBaseFormProps) => {
  const { investor, onChange } = props;

  const firstInputElRef = React.createRef<HTMLInputElement>();

  const [FormInvestor, setFormInvestor] = useState<
    api.DealInvestorCreate | api.DealInvestor
  >(null);

  useEffect(() => {
    setFormInvestor(investor);
  }, [investor]);

  useEffect(() => {
    if (firstInputElRef.current) {
      firstInputElRef.current.focus();
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const obj = { ...FormInvestor, [e.target.name]: e.target.value };
    setFormInvestor(obj);
    onChange(obj);
  };

  const handleTargetInvestmentChange = (amount: number) => {
    const obj = { ...FormInvestor, targetInvestment: amount };
    setFormInvestor(obj);
    onChange(obj);
  };

  const handleSwitcherChange = () => {
    const obj = { ...FormInvestor, isLead: !FormInvestor.isLead };
    setFormInvestor(obj);
    onChange(obj);
  };

  if (FormInvestor) {
    return (
      <div className="base-investor-form-container">
        <div className="section-title">Investor Information</div>
        <div className="investor-info-row">
          <div className="name">
            <DKFormTextInput
              dataTestId="investor-name-input"
              className="deals-input"
              required
              label="Investor Name"
              name="name"
              type="text"
              fullWidth={true}
              onChange={handleChange}
              value={FormInvestor.name}
              variant="outlined"
            />
          </div>
          <div className="target-investment">
            <DKFormMoneyInput
              dataTestId="target-investment-input"
              name={"targetInvestment"}
              label={"Target Investment"}
              required
              value={FormInvestor.targetInvestment}
              onChange={(value) => {
                handleTargetInvestmentChange(value);
              }}
            />
          </div>
        </div>
        <div className="investor-info-row">
          <div className="lead-investor-switcher-block">
            <Switcher
              dataTestId="investor-lead-investor-switcher-input"
              checked={FormInvestor.isLead}
              onChange={handleSwitcherChange}
            />
            <div
              data-testid="investor-lead-investor-switcher"
              className="lead-investor-switcher-label-container"
              onClick={handleSwitcherChange}
            >
              <div className="lead-investor-switcher-title">Lead Investor</div>
            </div>
          </div>
        </div>
        <div className="address">
          <div className="sub-section-title">Investor Address</div>
          <DKFormTextInput
            dataTestId="investor-address-line-input"
            className="deals-input line"
            required={false}
            label="Address"
            name="line"
            type="text"
            fullWidth={true}
            onChange={handleChange}
            value={FormInvestor.line}
            variant="outlined"
          />
          <div className="row-fields">
            <DKFormTextInput
              dataTestId="investor-address-city-input"
              className="deals-input city"
              label="City"
              name="city"
              type="text"
              fullWidth={true}
              onChange={handleChange}
              value={FormInvestor.city}
              variant="outlined"
            />
            <DKFormTextInput
              className="deals-input state"
              label="State"
              name="state"
              select
              fullWidth={true}
              onChange={handleChange}
              value={FormInvestor.state || ""}
              SelectProps={{
                native: true,
              }}
              variant="outlined"
            >
              {[
                { abbreviated: "", name: "", abbreviation: undefined },
                ...states,
              ].map((option) => {
                return (
                  <option
                    key={"abbreviation_" + option.abbreviation}
                    value={option.name}
                  >
                    {option.name}
                  </option>
                );
              })}
            </DKFormTextInput>
            <DKFormTextInput
              dataTestId="investor-address-zip-input"
              className="deals-input zip"
              label="Zip"
              name="zip"
              type="text"
              fullWidth={true}
              onChange={handleChange}
              value={FormInvestor.zip}
              variant="outlined"
            />
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default InvestorCreateBaseForm;
